import React from "react";

import OrganizationNewForm from "../components/organizationNew/OrganizationNewForm";
import {DebugElement} from "../Atollon/debug";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";
import {Card, CardText} from "react-md";

const OrganizationNew = ({ history }) => {
  return (
    <div className="flex-col">
        <DebugElement text={"src/containers/OrganizationNew.js"}/>
        <TouchPageHeader title={"Vytvořit účet organizace"}/>
        <TouchPageHeader_and_content_spaceBetween heightPx={45}/>
        <Card className="margin-bottom">
            <CardText>
                <OrganizationNewForm history={history}/>
            </CardText>
        </Card>
    </div>
  );
};

export default OrganizationNew;



// WEBPACK FOOTER //
// ./src/pages/OrganizationNew.js